module.exports = __webpack_public_path__ + "img/city-solid.331056ef.svg";